import { AnyAction } from "redux";
import {
  REQUEST_POST_CARD_TOKEN,
  REQUEST_POST_CARD_TOKEN_ERROR,
  REQUEST_POST_CARD_TOKEN_SUCCESS,
} from "redux/actions/general/cardToken";

const defaultState = {
  data: null,
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_POST_CARD_TOKEN:
      return {
        ...state,
        loading: true,
      };
    case REQUEST_POST_CARD_TOKEN_SUCCESS:
      return {
        data: action.cardToken,
        error: null,
        loading: false,
      };
    case REQUEST_POST_CARD_TOKEN_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
